import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  Tags, 
  ArrowLeftRight, 
  AlertTriangle,
  ChevronLeft,
  ChevronRight,
  Boxes
} from 'lucide-react';

const menuItems = [
  { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/products', icon: Package, label: 'Products' },
  { path: '/categories', icon: Tags, label: 'Categories' },
  { path: '/stock-movements', icon: ArrowLeftRight, label: 'Stock Movements' },
  { path: '/low-stock', icon: AlertTriangle, label: 'Low Stock' },
];

function Sidebar({ sidebarOpen, setSidebarOpen }) {
  return (
    <aside className={`fixed left-0 top-0 h-full bg-slate-900 text-white transition-all duration-300 z-50 ${sidebarOpen ? 'w-64' : 'w-16'}`}>
      <div className="flex items-center justify-between h-16 px-4 border-b border-slate-700">
        {sidebarOpen && (
          <div className="flex items-center gap-2">
            <Boxes className="w-6 h-6 text-primary-400" />
            <span className="font-bold text-lg">Inventory</span>
          </div>
        )}
        <button 
          onClick={() => setSidebarOpen(!sidebarOpen)}
          className="p-1 hover:bg-slate-700 rounded transition-colors"
        >
          {sidebarOpen ? <ChevronLeft className="w-5 h-5" /> : <ChevronRight className="w-5 h-5" />}
        </button>
      </div>
      
      <nav className="mt-4 px-2">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => 
              `flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 mb-1 ${
                isActive 
                  ? 'bg-primary-600 text-white' 
                  : 'text-slate-300 hover:bg-slate-800 hover:text-white'
              }`
            }
          >
            <item.icon className="w-5 h-5 flex-shrink-0" />
            {sidebarOpen && <span className="text-sm font-medium">{item.label}</span>}
          </NavLink>
        ))}
      </nav>
      
      {sidebarOpen && (
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-slate-700">
          <p className="text-xs text-slate-400">Inventory Management System</p>
          <p className="text-xs text-slate-500 mt-1">v1.0.0 Demo</p>
        </div>
      )}
    </aside>
  );
}

export default Sidebar;